var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components'; // Undraw is an MIT licensed illustration library
// See https://undraw.co

var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: auto;\n  max-height: ", ";\n  width: 100%;\n"], ["\n  height: auto;\n  max-height: ", ";\n  width: 100%;\n"])), function (p) {
  return "calc(" + p.theme.maxUndrawHeight + " * " + p.size + ")";
});

var Undraw = function Undraw(_a) {
  var alt = _a.alt,
      image = _a.image,
      _b = _a.size,
      size = _b === void 0 ? 1 : _b,
      props = __rest(_a, ["alt", "image", "size"]); // eslint-disable-next-line @typescript-eslint/no-var-requires


  var svg = require("../static/" + image + ".svg");

  return React.createElement(Flex, null, React.createElement(Image, Object.assign({
    src: svg,
    alt: alt ? alt : image,
    size: size
  }, props)));
};

export default Undraw;
var templateObject_1, templateObject_2;